import produce from "immer";
import moment from "moment";
import {
  RECORDING_LIST_REQUEST,
  RECORDING_LIST_SUCCESS,
  RECORDING_LIST_FAILURE,
  RECORDING_ADD_LIST,
  RECORDING_UPDATE_SUCCESS,
  RECORDING_REVIEW_SUCCESS,
  RECORDING_BULK_UPDATE_SUCCESS,
  COMMENT_LIST_SUCCESS,
  COMMENT_CREATE_SUCCESS,
  DATASET_PROCESS_SUCCESS,
  DATASET_DELETE_SUCCESS,
} from "../actions/types";

const recordingsInitState = {
  ids: [],
  hash: {},
  cachedAt: {},
  error: {},
  loading: {},
};

export const recordings = (state = recordingsInitState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // ---------------- REQUEST ----------------
      case RECORDING_LIST_REQUEST:
        draft.loading[action.projectId] = true;
        break;
      // ---------------- SUCCESS ----------------
      case RECORDING_ADD_LIST:
      case RECORDING_LIST_SUCCESS:
      case DATASET_PROCESS_SUCCESS:
        draft.loading[action.projectId] = false;
        const recordings = action.recordings;
        if (recordings.length) {
          draft.ids = draft.ids.filter(
            (id) => draft.hash[id].project_id !== action.projectId
          );
          recordings.forEach((recording) => {
            draft.ids.push(recording.id);
            draft.hash[recording.id] = recording;
            draft.hash[recording.id].comments = [];
          });
          draft.cachedAt[action.projectId] = moment();
        }
        break;
      case RECORDING_BULK_UPDATE_SUCCESS:
        let tmp_comments = [];
        action.recordings.forEach((recording) => {
          if (draft.ids.includes(recording.id)) {
            tmp_comments = draft.hash[recording.id].comments;
            draft.hash[recording.id] = recording;
            // add comments
            action.comments.forEach((comment) => {
              if (comment.recording_id === recording.id) {
                tmp_comments.push(comment.id);
              }
            });
            draft.hash[recording.id].comments = tmp_comments;
          }
        });
        break;
      case RECORDING_UPDATE_SUCCESS:
        const oldRec = draft.hash[action.recording.id];
        draft.hash[action.recording.id] = { ...oldRec, ...action.recording };
        break;
      case RECORDING_REVIEW_SUCCESS:
        draft.hash[action.recording.id].reviewer_status =
          action.recording.reviewer_status;
        break;
      case DATASET_DELETE_SUCCESS:
        draft.ids = draft.ids.filter((id) => {
          if (draft.hash[id].project_id === action.projectId) {
            delete draft.hash[id];
            return false;
          }
          return true;
        });
        break;
      // ---------------- FAILURE ----------------
      case RECORDING_LIST_FAILURE:
        draft.loading[action.projectId] = false;
        break;
      // ---------------- COMMENTS ----------------
      case COMMENT_LIST_SUCCESS:
        action.comments.forEach((comment) => {
          const recordingId = comment.recording_id;
          if (!draft.hash[recordingId].comments.includes(comment.id)) {
            draft.hash[recordingId].comments.push(comment.id);
          }
        });
        break;
      case COMMENT_CREATE_SUCCESS:
        draft.hash[action.comment.recording_id].comments.push(
          action.comment.id
        );
        break;
      default:
        break;
    }
  });
